module.exports = __webpack_public_path__ + "img/full0-min.7cf4e67b.png";